/**
 * @fileoverview NumberedListRenderer.module.css
 * Styles for the NumberedListRenderer component that displays a vertically stacked list
 * with numbered circular indicators next to each item.
 *
 * @example
 * // Basic usage with the NumberedListRenderer component
 * import css from './NumberedListRenderer.module.css'
 *
 * <div className={css.container}>
 *   <div className={css.row}>
 *     <span className={css.numeric}>1</span>
 *     <div>List item content</div>
 *   </div>
 * </div>
 */


.container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.row {
    display: flex;
    gap: 0.75rem;
    align-items: center;
}

.numeric {
    display: flex;
    place-content: center;
    align-items: center;
    border-radius: 50%;
    border: 1.6px solid var(--neutural900);
    background: var(--indigo50);
    width: 1.625rem;
    height: 1.625rem;
    box-sizing: border-box;
    flex-shrink: 0;
    color: var(--neutural900);
    font-weight: 500;
    font-size: 16px;
}
